import { useMemo } from 'react';
import { DropdownItemProps } from 'semantic-ui-react';
import useFetchAllAnalysts from '../analyst/useFetchAllAnalysts';

const UseFilterActiveAnalysts = (deactivatedAnalyst: string | undefined): DropdownItemProps[] | undefined => {
  const { data: allAnalysts } = useFetchAllAnalysts();

  return useMemo(() => {
    const activeAnalysts = allAnalysts?.filter((analyst) => {
      return analyst.isActiveAuthor || analyst.tagId === deactivatedAnalyst;
    });

    return activeAnalysts?.map(({ displayName, tagId }) => {
      return {
        text: displayName,
        value: tagId,
        key: tagId,
      };
    });
  }, [allAnalysts]);
};

export default UseFilterActiveAnalysts;
